import $ from 'jquery'
import './vendor/jquery.magnific-popup.js'
import './classes/polyfills.class.js'
import CellSlideshow from './classes/cell-slideshow.class.js'
import FAQ from './classes/faq.class.js'
import FormBehavior from './classes/form-behavior.class.js'
// import GradientPosition from './classes/gradient-position.class.js'
import Lollipop from './classes/lollipop.class.js'
import MainMenu from './classes/main-menu.class.js'
import CountrySelector from './classes/country-selector.class.js'
import PageDown from './classes/page-down.class.js'
import Slideshow from './classes/slideshow.class.js'
import CellAnimation from './classes/cell-animation.class.js'
import AnchorScroller from './classes/anchor-scroller';
import FixedHeader from './classes/fixed-header.class';
import Violator from './classes/violator.class';
// import Floating from './classes/floating.class.js'

const scroll = new AnchorScroller(144, 63, 767);
scroll.init();

$(() => {

  const finder = document.querySelector('#physician-finder')
  const parentWindow = window.parent;

  const violator = document.querySelector('.violator');
  if (violator) {
    new Violator(violator);
  }

  new FixedHeader();

  $(window).on('resize', () => {
    parentWindow.postMessage(document.body.clientHeight, "*")
  }).trigger('resize')


  const scrollArrow = document.querySelector('.scroll-arrow')
  if (scrollArrow) {
    new PageDown(scrollArrow)
  }

  const mainMenu = document.querySelector('.layout-container > header')
  if (mainMenu) {
    new MainMenu(mainMenu)
  }

  const countrySelector = document.querySelector('#block-countryselectormenu');
  if (countrySelector) {
    new CountrySelector(countrySelector);
  }

  const homepage = document.querySelector('#homepage-animation')
  if (homepage) {
    new CellAnimation()
  }

  // new GradientPosition(document.querySelector('section.paragraph--type--row:last-child .paragraph--type--cta'))

  document.querySelectorAll('.paragraph--type--cell-slideshow').forEach(slideshow => {
    new CellSlideshow(slideshow)
  })

  document.querySelectorAll('.webform-submission-form').forEach(f => {
    new FormBehavior(f)
  })

  document.querySelectorAll('.paragraph--type--collapsible-item').forEach(item => {
    new FAQ(item)

  })

  document.querySelectorAll('.paragraph--type--lollipop').forEach(item => {
    new Lollipop(item)
  })

  document.querySelectorAll('.paragraph--type--slideshow').forEach(slideshow => {
    new Slideshow(slideshow)
  })

  if ($('.popup-youtube').length) {
    $('.popup-youtube').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1&modestbranding=1&rel=0'
          }
        }
      },
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    })
  }

  if ($('.open-html-modal-link').length) {
    $('.open-html-modal-link').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    })
  }

  /*
  if (localStorage.getItem('visited') === null) {
    $.magnificPopup.open({
      items: {
        src: '#welcome-popup', // can be a HTML string, jQuery object, or CSS selector
        type: 'inline'
      },
      showCloseBtn: false,
      closeOnBgClick: false,
      mainClass: 'welcome-popup-container'

    });
  }
  $('#welcome-popup button').on( "click", function() {
    $.magnificPopup.close();
    localStorage.setItem('visited', 1);
  });
  */
  // new Floating()

  let videoSection = document.querySelector('.vc');

  if ($(videoSection).length) {
    let dtVideo = videoSection.querySelector('.desktop-video');
    let mVideo = videoSection.querySelector('.mobile-video');

    function PlayVideo(){
      if (window.innerWidth > 1025) {
        dtVideo.play();
      } else {
        mVideo.play();
      }
    }

    window.addEventListener('resize', () =>{
      PlayVideo();
    });

    PlayVideo()
  }
})



// WEBPACK FOOTER //
// ./js/main.js